import React, { FC, memo, useEffect } from 'react'

import { Route, Routes as RoutesList, useLocation } from 'react-router-dom'

import { fetchStatus } from '@/constants/common'
import { paths } from '@/constants/paths'
import { routes } from '@/constants/routes/routes'
import { useGatewayListener } from '@/hooks/useGatewayListener'
import { useKeyThrottle } from '@/hooks/useKeyThrottle'
import { useOpenAppController } from '@/hooks/useOpenAppController'
import { useCustomPalette } from '@/hooks/useSetPalette'
import useStore from '@/store/useStore'
import { sendPageViewEvent } from '@/utils/analyticsUtils'
import { sendPageImpressionToGTAG } from '@/utils/utils'

// import { updateUcStatus } from './actions/actions'

const RoutesRaw: FC = () => {
  const { pathname } = useLocation()
  const featureScreenData = useLocation().state || {}
  const appConfig = useStore((state) => state.common.appConfig)
  const consentStatus = useStore((state) => state.common.consentStatus)
  const setConsentStatus = useStore((state) => state.common.setConsentStatus)
  const isConsentCompleted = consentStatus === fetchStatus.COMPLETED

  useOpenAppController()
  useGatewayListener()
  useKeyThrottle()
  useCustomPalette()

  useEffect(() => {
    const userCentricsId = appConfig?.region?.userCentricsId || 'yg66BZnHi4yK4R'
    if (userCentricsId) {
      // updateUcStatus(userCentricsId)
    } else {
      setConsentStatus(fetchStatus.COMPLETED)
    }
  }, [])

  useEffect(() => {
    if (!isConsentCompleted) {
      return
    }
    const ignoredPaths = [
      paths.HOME,
      paths.SPECIAL_HOME,
      paths.SPORTS,
      paths.SELECTED_PAGE,
      paths.PAGE,
      paths.FOCUS_PAGE,
      paths.EVENT_PAGE,
    ]

    const isIgnoredPath = ignoredPaths.some((path) => pathname.includes(path))

    let path = isIgnoredPath ? '' : pathname

    const isFeatureScreen = pathname.includes(paths.FEATURE_SCREEN)
    if (isFeatureScreen) {
      const featureScreenId = featureScreenData?.featureScreen?.id
      path = `${pathname}/${featureScreenId}`
    }

    if (path) {
      sendPageViewEvent(path)
      sendPageImpressionToGTAG(path)
    }
  }, [pathname, isConsentCompleted])

  const renderRoutes = (routes: Route[]): JSX.Element => (
    <Route>
      {routes.map((route) => (
        <Route
          key={route.path}
          index={route.index || false}
          path={route.path}
          element={route.element}
        >
          {route.children && renderRoutes(route.children)}
        </Route>
      ))}
    </Route>
  )
  if (!isConsentCompleted) {
    return null
  }

  return <RoutesList>{renderRoutes(routes)}</RoutesList>
}

export const Routes = memo(RoutesRaw)
